module.exports = __webpack_public_path__ + "static/media/muzamil.3206db78.jpg";